// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"e2a559d6","377":"729fd8a3","399":"60f9c03f","440":"8a2f1495","534":"947daa25","545":"864c282b","612":"486af973","623":"c0328e2b","761":"71a98894"}[chunkId] + ".chunk.css";
};